import { z } from "zod";
import { LookupListPage } from "./LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { linkTypeCode: string; description: string; validForPeriodDays: number | null; linkPage: string | null; deleted: boolean; }
const schema = z.object({
  linkTypeCode: z.string().min(1).max(20),
  description: z.string().min(1).max(100),
  validForPeriodDays: z.number().int().positive().nullable().optional(),
  linkPage: z.string().max(200).nullable().optional(),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function IssuedLinkTypesPage() {
  return <LookupListPage<Row, Form>
    title="Issued link types"
    apiPath="/api/lookups/issued-link-types"
    schema={schema}
    rowKey={(r) => r.linkTypeCode}
    columns={[
      { id: "code",  header: "Code", accessor: (r) => r.linkTypeCode },
      { id: "desc",  header: "Description", accessor: (r) => r.description },
      { id: "days",  header: "Valid days", accessor: (r) => r.validForPeriodDays ?? "—", align: "right" },
      { id: "page",  header: "Link page", accessor: (r) => r.linkPage ?? "—" },
    ]}
    toFormValues={(r) => ({ linkTypeCode: r.linkTypeCode, description: r.description, validForPeriodDays: r.validForPeriodDays, linkPage: r.linkPage ?? "", deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ linkTypeCode: "", description: "", validForPeriodDays: 30, linkPage: "", deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="c">Code</Label><Input id="c" {...f.register("linkTypeCode")} /></div>
        <div><Label htmlFor="d">Description</Label><Input id="d" {...f.register("description")} /></div>
        <div><Label htmlFor="v">Valid for (days)</Label><Input id="v" type="number" {...f.register("validForPeriodDays", { valueAsNumber: true })} /></div>
        <div><Label htmlFor="p">Link page</Label><Input id="p" {...f.register("linkPage")} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
